module.exports = __webpack_public_path__ + "img/competition-card-background.e53a2ccb.svg";